import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { hasConsentDecision, isConsentGranted, reopenConsentBanner } from "@/lib/consent";

/**
 * Çerez tercihini görüntüleyip değiştirme.
 *
 * Rıza geri alınabilir ve yeniden verilebilir olmak zorunda. Bu bölüm
 * eklenene kadar bir kez "yalnızca gerekli" diyen kullanıcı 180 gün boyunca
 * kapalı kalıyordu ve arayüzde bunu değiştirebileceği hiçbir yer yoktu.
 */
export const ConsentSection: React.FC = () => {
  const { t } = useTranslation();

  // Banner cevabı çereze yazıyor; bu bölüm de aynı çerezi okuyor. Kullanıcı
  // banner'dan cevaplayınca metnin güncellenmesi için state'te tutuluyor.
  const [decided, setDecided] = React.useState(() => hasConsentDecision());
  const [granted, setGranted] = React.useState(() => isConsentGranted());

  const refresh = React.useCallback(() => {
    setDecided(hasConsentDecision());
    setGranted(isConsentGranted());
  }, []);

  React.useEffect(() => {
    // Banner kapandığında sekme odağa döndüğünde durum tazelensin.
    window.addEventListener("focus", refresh);
    return () => window.removeEventListener("focus", refresh);
  }, [refresh]);

  const statusKey = !decided
    ? "settings.permissions.consent.status.undecided"
    : granted
      ? "settings.permissions.consent.status.granted"
      : "settings.permissions.consent.status.denied";

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h4 className="text-md font-medium text-text-primary dark:text-text-primary">
          {t("settings.permissions.consent.title")}
        </h4>
        <p className="mt-1 text-sm text-text-tertiary dark:text-text-tertiary">
          {t("settings.permissions.consent.description")}
        </p>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-text-secondary dark:text-text-secondary">
          {t(statusKey)}
        </p>
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            reopenConsentBanner();
            refresh();
          }}
          // `outline` varyantı metin rengi tanımlamıyor, miras alıyor; koyu
          // temada koyu zemin üstünde koyu yazı çıkıyor.
          className="w-full text-text-primary dark:text-text-primary sm:w-auto"
        >
          {t("settings.permissions.consent.change")}
        </Button>
      </div>
    </div>
  );
};
